import { Box } from '@mui/material';
import { DialogTitle, CustomTextField, HorizontalForm, VerticalForm } from '../../../common';

const CredentialsSection = ({ selectedUser, onInputChange, isMobile, editMode }) => {
  if (isMobile) {
    return (
      <Box>
        <DialogTitle showSeparator={false}>Credenciales</DialogTitle>
        <VerticalForm>
          {!editMode && (
            <CustomTextField
              label="Contraseña"
              name="password"
              type="password"
              value={selectedUser.password || ''}
              onChange={onInputChange}
              size="medium"
            />
          )}
          <CustomTextField
            label="Zona Horaria"
            name="timezone"
            value={selectedUser.timezone || ''}
            onChange={onInputChange}
            size="medium"
          />
        </VerticalForm>
      </Box>
    );
  }

  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>
        Credenciales
      </DialogTitle>
      <HorizontalForm withBorder={false} sx={{ p: 1 }}>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
          <CustomTextField
            label="Contraseña"
            name="password"
            type="password"
            value={selectedUser.password || '*********'}
            onChange={onInputChange}
            size="medium"
            disabled={editMode}
          />
        </Box>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <CustomTextField
            label="Zona Horaria"
            name="timezone"
            value={selectedUser.timezone || ''}
            onChange={onInputChange}
            size="medium"
          />
        </Box>
      </HorizontalForm>
    </Box>
  );
};

export default CredentialsSection;
